<template>
  <div class="page-header align-items-start min-vh-100">
    <div class="container-fluid min-vh-100 m-0 px-0">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "AccountLayout",
};
</script>

<style lang="scss" scoped>
.page-header {
  background: linear-gradient(45deg, rgba(191, 31, 34, 0.33) 0%, rgba(112, 15, 17, 0.8)), url(https://clubcows.com/storage/app/public/login-bg.jpg);
  background-size: cover;
}
</style>
